export default __webpack_public_path__ + "static/media/slide11.f8ac452f.jpg";